import "../scss/blog_categories.scss"
import $ from 'jquery'
